
import React from 'react';
import { USER_AVATAR, FLAG_BR } from '../constants';

const Header: React.FC<{ title: string }> = ({ title }) => {
  return (
    <header className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 h-16 flex items-center justify-between px-8 sticky top-0 z-40 backdrop-blur-sm bg-white/80 dark:bg-slate-900/80">
      <div className="flex items-center gap-4">
        <button className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full text-slate-500">
          <span className="material-icons-round">menu</span>
        </button>
        <h2 className="font-semibold text-lg dark:text-white">{title}</h2>
      </div>
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 text-sm font-medium text-slate-600 dark:text-slate-300">
          <span>CLP$</span>
          <div className="flex items-center gap-1 bg-slate-100 dark:bg-slate-800 px-2 py-1 rounded cursor-pointer hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors">
            <img alt="Brazil Flag" className="w-5 h-auto rounded-sm" src={FLAG_BR} />
            <span className="material-icons-round text-xs">keyboard_arrow_down</span>
          </div>
        </div>
        <div className="relative cursor-pointer group">
          <button className="p-2 text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full transition-colors">
            <span className="material-icons-round">notifications</span>
          </button>
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 border-2 border-white dark:border-slate-900 rounded-full group-hover:animate-ping"></span>
        </div>
        <div className="flex items-center gap-3 pl-6 border-l border-slate-200 dark:border-slate-800">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold dark:text-white">Thiago Andrade</p>
            <p className="text-[10px] text-slate-400 uppercase tracking-tighter">Administrador</p>
          </div>
          <img alt="Profile" className="w-10 h-10 rounded-full border border-slate-200 dark:border-slate-700 ring-2 ring-primary/20" src={USER_AVATAR} />
        </div>
      </div>
    </header>
  );
};

export default Header;
